import type { ComponentProps, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

const Container: FC<ComponentProps<'div'>> = ({ className, ...props }): ReactNode => {
    return (
        <div
            className={cn('mx-auto w-full max-w-7xl px-5 sm:px-8', className)}
            {...props}
        />
    )
}

export default Container
